var GeoLevel;
(function (GeoLevel) {
    GeoLevel[GeoLevel["Italia"] = 0] = "Italia";
    GeoLevel[GeoLevel["RegionAndNearRegions"] = 1] = "RegionAndNearRegions";
    GeoLevel[GeoLevel["Region"] = 2] = "Region";
    GeoLevel[GeoLevel["City"] = 3] = "City";
    GeoLevel[GeoLevel["Town"] = 4] = "Town";
})(GeoLevel || (GeoLevel = {}));

export { GeoLevel };
//# sourceMappingURL=types.js.map
